import { render } from "./DeleteScreenModal.vue?vue&type=template&id=453d3ba6"
import script from "./DeleteScreenModal.vue?vue&type=script&lang=js"
export * from "./DeleteScreenModal.vue?vue&type=script&lang=js"

import "./DeleteScreenModal.vue?vue&type=style&index=0&id=453d3ba6&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__